<script lang="ts" setup>
import { cva, VariantProps } from 'class-variance-authority'
import { computed } from 'vue'
import { PhCheckCircle, PhXCircle } from '@phosphor-icons/vue'

import { classMerge } from '@toni/brand-ui'

const reviewHeadingVariants = cva('font-heading', {
  variants: {
    type: {
      pros: 'text-positive-foreground',
      cons: 'text-negative-foreground'
    },
    variant: {
      full: 'text-heading-sm',
      column: 'text-heading-2xs'
    }
  },
  defaultVariants: {
    type: 'pros',
    variant: 'full'
  }
})

type ReviewHeadingProps = VariantProps<typeof reviewHeadingVariants>

const props = withDefaults(
  defineProps<{
    type?: ReviewHeadingProps['type']
    variant?: ReviewHeadingProps['variant']
    title?: string
  }>(),
  {
    type: 'pros',
    variant: 'full',
    title: ''
  }
)
const iconSize = computed(() => {
  return props.variant === 'full' ? '24' : '20'
})
</script>

<template>
  <div :class="`flex items-center ${variant === 'full' ? 'gap-1.5' : 'gap-1'}`">
    <PhCheckCircle v-if="type === 'pros'"
                   class="text-positive-foreground"
                   :size="iconSize"
                   weight="fill" />
    <PhXCircle v-else-if="type === 'cons'"
               class="text-negative-foreground"
               :size="iconSize"
               weight="fill" />
    <span :class="classMerge(reviewHeadingVariants({ type, variant }), $attrs.class ?? '')">
      {{ title || $t(`commerce.${type}`) }}
    </span>
  </div>
</template>
